import { render, staticRenderFns } from "./_Company.vue?vue&type=template&id=4897b55f&scoped=true&"
import script from "./_Company.vue?vue&type=script&lang=js&"
export * from "./_Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897b55f",
  null
  
)

export default component.exports